/* squiq-preorder-pickup.js
   SQUIQ — aus layout/theme.liquid herausgeloest (D1-Migration Be Yours 9.5.1, TSK-1740).
   Zweck: blendet die Abhol-Verfuegbarkeit auf Produktseiten aus, solange der
          Kaufbutton ein Vorbestell-Label traegt.
   Grund der Auslagerung: ein Theme-Update setzt Vanilla-Dateien byte-genau zurueck.
   Code in einer eigenen Datei ueberlebt jedes Update; Code IN einer Theme-Datei nicht.
   Eingebunden in layout/theme.liquid. Inhalt unveraendert uebernommen. */
(function () {
  // nur Produktseiten (Be Yours)
  if (!document.body.classList.contains('template-product')) return;

  const PREORDER_WORDS = ["vorbestellen", "vorbestellung", "preorder", "pre-order"];

  function isPreorderActive() {
    // Be Yours / Apps: verschiedene mögliche ATC Buttons
    const candidates = [
      'button[name="add"]',
      'button[type="submit"]',
      '.product-form__submit',
      '[data-atc-button]',
      'form[action*="/cart/add"] button'
    ];

    const btns = document.querySelectorAll(candidates.join(','));
    if (!btns.length) return false;

    return Array.from(btns).some(btn => {
      const t = (btn.innerText || btn.textContent || "").toLowerCase();
      return PREORDER_WORDS.some(w => t.includes(w));
    });
  }

  function hidePickup() {
    if (!isPreorderActive()) return;

    // breit genug, damit wirklich alles verschwindet
    const pickupSelectors = [
      'pickup-availability',
      'pickup-availability-preview',
      '.pickup-availability-info'
    ];

    document.querySelectorAll(pickupSelectors.join(',')).forEach(el => {
      el.style.display = 'none';
    });
  }

  // sofort + mehrfach (weil Globo/Theme nachlädt)
  function runBurst() {
    hidePickup();
    setTimeout(hidePickup, 200);
    setTimeout(hidePickup, 600);
    setTimeout(hidePickup, 1200);
    setTimeout(hidePickup, 2500);
  }

  document.addEventListener('DOMContentLoaded', runBurst);

  // beobachte Änderungen (Variant Switch / App Updates)
  const obs = new MutationObserver(() => runBurst());
  obs.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
